import React, { forwardRef, memo } from 'react'

const ShopIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      {...props}>
      <circle
        cx="28"
        cy="28"
        r="26.8706"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="2.259"
      />
      <path
        d="M34.65 26.6C36.0031 26.6 37.1 25.5031 37.1 24.15C37.1 22.7969 36.0031 21.7 34.65 21.7C33.2969 21.7 32.2 22.7969 32.2 24.15C32.2 25.5031 33.2969 26.6 34.65 26.6Z"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 35H18.2C18.0144 35 17.8363 34.9262 17.707 34.7969C17.5777 34.6676 17.5039 34.4895 17.5 34.304V30.8C17.5039 30.6145 17.5777 30.4364 17.707 30.3071C17.8363 30.1778 18.0144 30.104 18.2 30.1H21"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6 30.8H29.4L35.2625 29.4517C35.478 29.3926 35.7043 29.3839 35.9237 29.4266C36.1431 29.4693 36.3517 29.562 36.5274 29.6973C36.703 29.8326 36.8413 30.0069 36.9306 30.2041C37.0199 30.4013 37.0587 30.6159 37.06 30.8337C37.0601 31.1214 37.025 31.406 36.9561 31.6795C36.8873 31.953 36.7852 32.2116 36.6555 32.442L32.9 34L27.3 35H21V30.1L23.1875 27.9125C23.383 27.717 23.6149 27.5513 23.8714 27.4242C24.1279 27.2971 24.4049 27.2102 24.691 27.169H29.05C29.5141 27.169 29.9612 27.4844 30.2875 27.8126C30.6138 28.1409 30.83 28.5879 30.83 29.052C30.83 29.5162 30.6138 29.9631 30.2875 30.2914C29.9612 30.6197 29.5141 30.9351 29.05 30.9351H26.6V30.8Z"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2 24.2628C31.7246 24.4876 31.1893 24.5535 30.6734 24.4507C30.1576 24.348 29.6847 24.0816 29.3357 23.6916C28.9867 23.3017 28.7788 22.8095 28.736 22.2931C28.6931 21.7767 28.8162 21.2607 29.0885 20.8204C29.3609 20.3801 29.7699 20.0391 30.2523 19.8402C30.7347 19.6412 31.2635 19.5943 31.7646 19.7064C32.2657 19.8186 32.7149 20.0841 33.0484 20.464C33.382 20.8439 33.5822 21.3175 33.6001 21.8369"
        stroke="#78BE20"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

ShopIcon.displayName = 'ShopIcon'

export default memo(ShopIcon)
